import Axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { Config as _Config } from '@services/lib/config';

export const Config = _Config;

declare const Session: any;

export interface IResponse<T> {
  code: number;
  data: T;
  msg: string;
}
export interface ISuccessRequestConfig extends AxiosRequestConfig {
  successCode?: string;
}
class Request {
  private static getData<T extends IResponse<any>>(
    response: AxiosResponse<T>,
    extSuccessCode?: string | number
  ): T['data'] {
    const { data } = response;
    if (data.code === 0 || ('code' in data && data.code === extSuccessCode)) {
      return data.data;
    } else {
      throw data;
    }
  }

  public async $get<T>(
    url: string,
    options?: AxiosRequestConfig,
    extSuccessCode?: string | number
  ): Promise<T> {
    const axios = await this.getAxios();
    return Request.getData<IResponse<T>>(
      await axios.get<IResponse<T>>(url, {
        baseURL: Config.BASE_URL,
        ...options
      }),
      extSuccessCode
    );
  }

  public async $post<T>(url: string, data?: any, options?: ISuccessRequestConfig): Promise<T> {
    const axios = await this.postAxios();
    return Request.getData<IResponse<T>>(
      await axios.post<IResponse<T>>(Config.BASE_URL + url, data, options),
      options && options.successCode
    );
  }
  public async $postJson<T>(url: string, data?: any, options?: AxiosRequestConfig): Promise<T> {
    const axios = await this.postAxios();
    return Request.getData<IResponse<T>>(
      await axios.post<IResponse<T>>(url, data, {
        baseURL: Config.BASE_URL,
        ...(options || {})
      }),
      '0000'
    );
  }

  private getAxios(): Promise<AxiosInstance> {
    return new Promise((resolve, reject) =>
      Session.getToken(
        ({ token }: { token: string }) => resolve(Axios.create({ params: { token } })),
        reject
      )
    );
  }

  private postAxios(): Promise<AxiosInstance> {
    return new Promise((resolve, reject) =>
      Session.getToken(
        ({ token }: { token: string }) =>
          resolve(
            Axios.create({
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              params: { token }
            })
          ),
        reject
      )
    );
  }
}

export default new Request();



// WEBPACK FOOTER //
// ./src/services/lib/request.ts